module.exports = __webpack_public_path__ + "static/Odlew postaci Wojciecha Bogusławskiego (1936 r.) NAC-4adad327337fe35ad0660ccaf317c731.jpg";